import React from "react";

import logo from "assets/img/henry-schein-logo-png-transparent.png";
import sidelogo from "assets/img/HS_Thrive Unlocked__Lockup.png";

import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import ThriveSignaturegep from 'assets/img/Thrive Signaturegep.png';
import landinglogo from 'assets/img/hs_landing.png';
import bannerImage from 'assets/img/landingbanner.png';



export default function ThriveSignatureEligibility({setNext,
  signatureData,}) {
 const membershipData = {
  practiceName:
    signatureData?.practice_name ||
    signatureData?.practiceName ||
    "",

  locationAccountNumber:
    signatureData?.locationAccountNumber ||
    signatureData?.location_account_number ||
    signatureData?.shipto ||
    "",

  status: "Active",

  subscriptionPlan: signatureData?.plan
    ? `${signatureData.plan} Plan`
    : "",

  price:
    signatureData?.plan === "Monthly"
      ? "$115 per month"
      : signatureData?.plan === "Yearly"
      ? "$1,299 per year"
      :signatureData?.trialperiod,

  pointOfContact: {
    name:
      `${signatureData?.contactfirstname || ""} ${
        signatureData?.contactlastname || ""
      }`.trim(),

    email: signatureData?.customeremail || "",
  },

  supportEmail: "Thrive.Support@HenrySchein.com",
};

  const handleCheckDifferentAccount = () => {
    // Reset the eligibility form / go back to account number entry
    setNext("")
  };

  return (
    <>
      <style>{eligibilityCss}</style>

      <div className="eligibility-page">

        {/* =====================================================
            TOP BANNER
        ===================================================== */}

        <div className="top-banner">
            <img
                      src={bannerImage}
                      alt="Thrive Signature"
                      className="top-banner-image"
                    />

          <div className="eligibility-banner-content">

            <div className="eligibility-brand">

              <img
                src={landinglogo}
                alt="Henry Schein"
                className="eligibility-hs-logo"
              />

              {/* <img
                src={sidelogo}
                alt="Thrive"
                className="eligibility-thrive-logo"
              /> */}

            </div>

            <div className="eligibility-brand-divider" />

            <div className="eligibility-tagline">
              Save More. Do More. <span>Thrive.</span>
            </div>

          </div>

        </div>


        {/* =====================================================
            MAIN CARD
        ===================================================== */}

        <div className="eligibility-card">

          {/* ===================================================
              PROGRESS STEPS
          =================================================== */}

          <div className="eligibility-steps">

            <EligibilityStep
              number="1"
              title="Check Eligibility"
              active
            />

            <div className="eligibility-step-line" />

            <EligibilityStep
              number="2"
              title="Review & Accept"
            />

            <div className="eligibility-step-line" />

            <EligibilityStep
              number="3"
              title="Confirmation"
            />

          </div>


          {/* ===================================================
              PAGE TITLE
          =================================================== */}

          <h1 className="eligibility-title">
            Thrive Signature Eligibility
          </h1>


          {/* ===================================================
              ALREADY ENROLLED CARD
          =================================================== */}

          <div className="enrolled-card">

            {/* BRAND */}

            <div className="enrolled-brand">

              <img
                src={ThriveSignaturegep}
                alt="Henry Schein"
              />

              {/* <div className="enrolled-thrive">
                thrive
                <span>Signature</span>
              </div> */}

            </div>


            {/* INFO ICON */}

            <div className="enrolled-icon-outer">

              <div className="enrolled-icon-inner">

                <InfoOutlinedIcon />

              </div>

            </div>


            {/* HEADING */}

            <h2 className="enrolled-heading">
              Already Enrolled
            </h2>


            <p className="enrolled-text">

              This Location Account Number is already associated{' '}

              <br className="desktop-break" />

              with an active Thrive Signature membership.{' '}

              <br className="desktop-break" />

              No additional enrollment is needed.

            </p>


            <div className="enrolled-divider" />


            {/* =================================================
                CURRENT MEMBERSHIP
            ================================================= */}

            <div className="membership-section">

              <h3>
                Current Membership
              </h3>


              <MembershipRow
                label="Practice Name:"
                value={membershipData.practiceName}
              />


              <MembershipRow
                label="Location Account Number:"
                value={membershipData.locationAccountNumber}
              />


              <div className="membership-row">

                <div className="membership-label">
                  Status:
                </div>

                <div className="membership-value">

                  <span className="status-badge">

                    <span className="status-dot" />

                    {membershipData.status}

                  </span>

                </div>

              </div>


              <div className="membership-row">

                <div className="membership-label">
                  Subscription Plan:
                </div>

                <div className="membership-value">

                  <div>
                    {membershipData.subscriptionPlan}
                  </div>

                  <div className="membership-muted">
                    {membershipData.price}
                  </div>

                </div>

              </div>


              <div className="membership-row last-row">

                <div className="membership-label">
                  Point of Contact:
                </div>

                <div className="membership-value">

                  <div>
                    {membershipData.pointOfContact.name}
                  </div>

                  <div className="membership-muted"style={{overflowWrap: "anywhere"}}>
                    {membershipData.pointOfContact.email}
                  </div>

                </div>

              </div>

            </div>


            {/* =================================================
                BUTTON
            ================================================= */}

            <button
              type="button"
              className="different-account-button"
              onClick={handleCheckDifferentAccount}
            >
              Check a Different Account Number
            </button>

          </div>


          {/* =====================================================
              BOTTOM INFO STRIP
              NOW INSIDE MAIN CARD
          ===================================================== */}

           <div className="information-section">
            <InformationItem
              icon={<StarBorderIcon />}
              title="Your Rewards membership stays active"
              description={
                <>
                  Upgrading adds Signature benefits{' '}
                  <br className="desktop-break" />
                  to your existing Thrive Rewards{' '}
                  <br className="desktop-break" />
                  membership.
                </>
              }
            />

            <div className="information-divider" />

          <InformationItem
            icon={<HelpOutlineIcon />}
            title="Questions?"
            description={
              <>
                Contact your Henry Schein Sales{" "}
                <br className="desktop-break" />
                Consultant or{" "}
                <br className="desktop-break" />
                <a
                  href="mailto:Thrive.Support@henryschein.com"
                  style={{
                    color: "#173bb8",
                    textDecoration: "underline",
                  }}
                >
                  Thrive.Support@henryschein.com
                </a>
              </>
            }
          />

            <div className="information-divider" />

            <InformationItem
              icon={<LockOutlinedIcon />}
              title="Secure Enrollment"
              description="Your information is protected."
            />
          </div>

        </div>

      </div>
    </>
  );
}


/* =========================================================
   PROGRESS STEP
========================================================= */

const EligibilityStep = ({
  number,
  title,
  active = false,
}) => {
  return (
    <div
      className={`eligibility-step ${
        active ? "active" : ""
      }`}
    >

      <div className="eligibility-step-circle">
        {number}
      </div>

      <div className="eligibility-step-title">
        {title}
      </div>

    </div>
  );
};


/* =========================================================
   MEMBERSHIP ROW
========================================================= */

const MembershipRow = ({
  label,
  value,
}) => {
  return (
    <div className="membership-row">

      <div className="membership-label">
        {label}
      </div>

      <div className="membership-value">
        {value}
      </div>

    </div>
  );
};


/* =========================================================
   BOTTOM INFO ITEM
========================================================= */

const InformationItem = ({ icon, title, description }) => {
  return (
    <div className="information-item">
      <div className="information-icon">{icon}</div>

      <div className="information-content">
        <div className="information-title">{title}</div>

        <div className="information-description">{description}</div>
      </div>
    </div>
  );
};


/* =========================================================
   CSS
========================================================= */

const eligibilityCss = `

* {
  box-sizing: border-box;
}


/* =========================================================
   PAGE
========================================================= */

.eligibility-page {
  width: 100%;

  min-height: 100vh;

  margin: 0;

  padding: 0 0 24px;

  background: #ffffff;

  font-family:
    Arial,
    Helvetica,
    sans-serif;

  color: #1638ca;

  overflow-x: hidden;
}


/* =========================================================
   TOP BANNER
========================================================= */

// .eligibility-banner {
//   width: 100%;

//   height: 120px;

//   position: relative;

//   overflow: hidden;

//   background:
//     linear-gradient(
//       135deg,
//       #e3f6ff 0%,
//       #d1edfc 20%,
//       #edfaff 42%,
//       #ccecff 65%,
//       #e7f7ff 100%
//     );
// }


/* =========================================================
   LEFT DECORATION
========================================================= */

// .eligibility-banner::before {
//   content: "";

//   position: absolute;

//   left: -30px;

//   top: -60px;

//   width: 220px;

//   height: 190px;

//   background:
//     linear-gradient(
//       135deg,
//       transparent 45%,
//       rgba(
//         82,
//         174,
//         241,
//         0.30
//       ) 46%,
//       rgba(
//         82,
//         174,
//         241,
//         0.30
//       ) 65%,
//       transparent 66%
//     );
// }


/* =========================================================
   RIGHT DECORATION
========================================================= */

// .eligibility-banner::after {
//   content: "";

//   position: absolute;

//   right: 30px;

//   top: -70px;

//   width: 260px;

//   height: 200px;

//   background:
//     linear-gradient(
//       135deg,
//       transparent 45%,
//       rgba(
//         75,
//         166,
//         231,
//         0.20
//       ) 46%,
//       rgba(
//         75,
//         166,
//         231,
//         0.20
//       ) 65%,
//       transparent 66%
//     );
// }

.top-banner {
  width: 100%;
  height: 110px;
  position: relative;
  overflow: hidden;
  background: none;
}

.top-banner-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.banner-inner {
  position: relative;
  z-index: 2;
  /* existing styles */
}

/* =========================================================
   BANNER CONTENT
========================================================= */

.eligibility-banner-content {
  width: 100%;

  max-width: 720px;

  height: 100px;

  margin: 0 auto;

  padding: 10px 20px;

  position: relative;

  z-index: 2;

  display: flex;

  align-items: center;

  gap: 14px;
}


/* =========================================================
   BRAND
========================================================= */

.eligibility-brand {
  display: flex;

  flex-direction: column;

  align-items: flex-start;

  flex-shrink: 0;
}


.eligibility-hs-logo {
  width: 105px;

  height: auto;

  object-fit: contain;
}


.eligibility-thrive-logo {
  width: 110px;

  height: auto;

  margin-top: -2px;

  object-fit: contain;
}


.eligibility-brand-divider {
  width: 1px;

  height: 44px;

  background: #6f8fb8;
}


.eligibility-tagline {
  color: #103cd2;

  font-size: 18px;

  line-height: 22px;

  font-weight: 700;

  white-space: nowrap;
}


.eligibility-tagline span {
  color: #2f9be8;
}


/* =========================================================
   MAIN CARD
========================================================= */

.eligibility-card {
  width: calc(100% - 28px);

  max-width: 720px;

  margin: -30px auto 0;

  padding: 16px 24px 30px;

  position: relative;

  z-index: 5;

  background:
    rgba(
      255,
      255,
      255,
      0.98
    );

  border:
    1px solid #dceaf8;

  border-radius: 5px;

  box-shadow:
    0 5px 20px
    rgba(
      28,
      119,
      206,
      0.15
    );
}


/* =========================================================
   STEPS
========================================================= */

.eligibility-steps {
  width: 100%;

  display: flex;

  align-items: flex-start;

  justify-content: center;

  margin: 0 auto 22px;
}


.eligibility-step {
  width: 120px;

  flex-shrink: 0;

  display: flex;

  flex-direction: column;

  align-items: center;

  text-align: center;
}


.eligibility-step-circle {
  width: 22px;

  height: 22px;

  border-radius: 50%;

  display: flex;

  align-items: center;

  justify-content: center;

  background: #e9effb;

  border:
    1px solid #cbd9f1;

  color: #7185c2;

  font-size: 10px;

  font-weight: 700;
}


.eligibility-step.active
.eligibility-step-circle {
  background: #1677e8;

  border-color: #1677e8;

  color: #ffffff;

  box-shadow:
    0 2px 5px
    rgba(
      20,
      112,
      229,
      0.22
    );
}


.eligibility-step-title {
  margin-top: 5px;

  color: #1b43cf;

  font-size: 9px;

  line-height: 11px;

  font-weight: 600;

  white-space: nowrap;
}


.eligibility-step-line {
  width: 90px;

  height: 1px;

  margin-top: 11px;

  background: #d2def1;
}


/* =========================================================
   TITLE
========================================================= */

.eligibility-title {
  margin: 0 0 20px;

  text-align: center;

  color: #1026c9;

  font-size: 28px;

  line-height: 34px;

  font-weight: 700;
}


/* =========================================================
   ALREADY ENROLLED CARD
========================================================= */

.enrolled-card {
  width: 100%;

  max-width: 370px;

  margin: 0 auto;

  padding: 18px 20px 20px;

  border:
    1.5px solid #4da6f0;

  border-radius: 5px;

  background: #ffffff;

  box-shadow:
    0 3px 12px
    rgba(
      45,
      130,
      220,
      0.12
    );

  text-align: center;
}


/* =========================================================
   BRAND
========================================================= */

.enrolled-brand {
  display: flex;

  flex-direction: column;

  align-items: center;

  margin-bottom: 14px;
}


.enrolled-brand img {
  width: 140px;

  height: auto;

  object-fit: contain;
}


.enrolled-thrive {
  margin-top: -2px;

  color: #0785ed;

  font-size: 44px;

  line-height: 42px;

  font-weight: 700;

  letter-spacing: -2px;

  text-align: right;
}


.enrolled-thrive span {
  display: block;

  margin-top: 1px;

  color: #1473db;

  font-size: 11px;

  line-height: 12px;

  letter-spacing: 0;

  font-weight: 400;

  text-align: right;
}


/* =========================================================
   INFO ICON
========================================================= */

.enrolled-icon-outer {
  width: 64px;

  height: 64px;

  margin: 0 auto 10px;

  border-radius: 50%;

  display: flex;

  align-items: center;

  justify-content: center;

  background: #d9efff;
}


.enrolled-icon-inner {
  width: 44px;

  height: 44px;

  border-radius: 50%;

  display: flex;

  align-items: center;

  justify-content: center;

  background: #ffffff;

  color: #1238d4;
}


.enrolled-icon-inner svg {
  width: 42px;

  height: 42px;
}


/* =========================================================
   HEADING + TEXT
========================================================= */

.enrolled-heading {
  margin: 0 0 10px;

  color: #1026c9;

  font-size: 24px;

  line-height: 28px;

  font-weight: 700;
}


.enrolled-text {
  margin: 0;

  color: #5f76b8;

  font-size: 11px;

  line-height: 16px;

  font-weight: 400;
}


.enrolled-divider {
  width: 100%;

  height: 1px;

  margin: 14px 0 12px;

  background: #dbe5f3;
}


/* =========================================================
   CURRENT MEMBERSHIP
========================================================= */

.membership-section {
  width: 100%;

  text-align: left;

  margin-bottom: 16px;
}


.membership-section h3 {
  margin: 0 0 8px;

  color: #102bc9;

  font-size: 15px;

  line-height: 19px;

  font-weight: 700;
}


.membership-row {
  width: 100%;

  display: grid;

  grid-template-columns: 135px 1fr;

  column-gap: 8px;

  padding: 7px 0;

  align-items: center;

  border-bottom:
    1px solid #e1e9f4;
}


.membership-row.last-row {
  border-bottom: none;
}


.membership-label {
  color: #2441a3;

  font-size: 10px;

  line-height: 14px;

  font-weight: 400;
}


.membership-value {
  color: #1b2f8f;

  font-size: 10px;

  line-height: 14px;

  font-weight: 400;
}


.membership-muted {
  color: #6073a9;
}


/* =========================================================
   STATUS BADGE
========================================================= */

.status-badge {
  display: inline-flex;

  align-items: center;

  gap: 6px;

  padding: 3px 12px;

  border-radius: 12px;

  background: #e4f4e7;

  color: #3b9650;

  font-size: 10px;

  line-height: 14px;

  font-weight: 400;
}


.status-dot {
  width: 6px;

  height: 6px;

  border-radius: 50%;

  background: #4ca05d;
}


/* =========================================================
   BUTTON
========================================================= */

.different-account-button {
  width: 100%;

  height: 34px;

  border: none;

  border-radius: 3px;

  background: #0879ed;

  color: #ffffff;

  font-family:
    Arial,
    Helvetica,
    sans-serif;

  font-size: 12px;

  line-height: 16px;

  font-weight: 700;

  cursor: pointer;

  box-shadow:
    0 2px 5px
    rgba(
      0,
      100,
      220,
      0.18
    );

  transition:
    background 0.15s ease;
}


.different-account-button:hover {
  background: #066bd3;
}


/* =========================================================
   BOTTOM INFO STRIP
   INSIDE MAIN CARD
========================================================= */

.info-strip {
  width: 100%;

  max-width: none;

  margin: 16px 0 0;

  padding: 12px 16px;

  display: flex;

  align-items: center;

  justify-content: space-between;

  border-top:
    1px solid #d5e4f6;

  // background: #f5faff;
}


.info-strip-line {
  width: 1px;

  align-self: stretch;

  background: #d5e4f6;

  margin: 0 12px;
}


.info-item {
  flex: 1;

  display: flex;

  align-items: flex-start;

  gap: 8px;
}


.info-item-icon {
  width: 30px;

  height: 30px;

  flex-shrink: 0;

  border-radius: 50%;

  display: flex;

  align-items: center;

  justify-content: center;

  background: #d9efff;

  color: #126de2;
}


.info-item-icon svg {
  width: 17px;

  height: 17px;
}


.info-item-title {
  color: #173bb8;

  font-size: 9px;

  line-height: 12px;

  font-weight: 700;

  margin-bottom: 2px;
}


.info-item-description {
  color: #6d7fae;

  font-size: 8px;

  line-height: 11px;
}


.info-item-description a {
  color: #173bb8;

  text-decoration: underline;
}

.information-section {
  width: 100%;
  margin: 20px auto 0;
  padding: 12px 6px 4px;
  display: flex;
  align-items: stretch;
  border-top: 1px solid #C9D9EC;
}

.information-item {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 10px;
}

.information-icon {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #DCEEFF;
  color: #176DE2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.information-icon svg {
  font-size: 18px;
}

.information-content {
  min-width: 0;
}

.information-title {
  color: #1456D8;
  font-size: 9px;
  line-height: 12px;
  font-weight: 700;
  margin-bottom: 2px;
}

.information-description {
  color: #5871D2;
  font-size: 8.5px;
  line-height: 11px;
}

.information-divider {
  width: 1px;
  background: #CBD9EC;
  flex-shrink: 0;
}



/* =========================================================
   TABLET
========================================================= */

@media only screen and (max-width: 768px) {

  .eligibility-banner {
    height: 105px;
  }


  .eligibility-banner-content {
    height: 88px;

    padding: 8px 14px;
  }


  .eligibility-tagline {
    font-size: 15px;
  }


  .eligibility-card {
    width: calc(100% - 20px);

    padding:
      14px 16px 24px;
  }


  .info-strip {
    width: 100%;
  }

}


/* =========================================================
   MOBILE
========================================================= */

@media only screen and (max-width: 480px) {

  .eligibility-banner {
    height: 88px;
  }


  .eligibility-banner-content {
    height: 74px;

    padding:
      6px 10px;

    gap: 8px;
  }


  .eligibility-hs-logo {
    width: 58px;
  }


  .eligibility-thrive-logo {
    width: 80px;
  }


  .eligibility-brand-divider {
    height: 34px;
  }


  .eligibility-tagline {
    font-size: 11px;

    line-height: 14px;
  }


  .eligibility-card {
    width: calc(100% - 12px);

    margin-top: -26px;

    padding:
      10px 10px 18px;
  }


  .eligibility-steps {
    margin-bottom: 14px;
  }


  .eligibility-step {
    width: 76px;
  }


  .eligibility-step-title {
    font-size: 7px;
  }


  .eligibility-step-line {
    width: 40px;
  }


  .eligibility-title {
    font-size: 20px;

    line-height: 25px;

    margin-bottom: 14px;
  }


  .enrolled-card {
    padding:
      14px 12px 16px;
  }


  .enrolled-heading {
    font-size: 20px;
  }


  .enrolled-text {
    font-size: 10px;

    line-height: 14px;
  }


  .desktop-break {
    display: none;
  }


  .membership-row {
    grid-template-columns:
      105px 1fr;
  }


  /* INFO STRIP NOW INSIDE CARD */

  .info-strip {
    width: 100%;

    flex-direction: column;

    align-items: stretch;

    gap: 10px;
  }


  .info-strip-line {
    width: 100%;

    height: 1px;

    margin: 0;
  }

  .information-section {
    flex-direction: column;
    gap: 12px;
    padding: 12px 4px 4px;
  }

  .information-item {
    padding: 0 4px;
  }

  .information-divider {
    width: 100%;
    height: 1px;
  }

}

`;